import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Card, CardContent } from '@material-ui/core';
import useLoanOfficerDashboard from 'reducers/hooks/useLoanOfficerDashboard';
import calculateStats from 'utils/loanOfficerDashboardHelper';
import Icon from 'sharedComponents/Icon';
import Seo from 'sharedComponents/Seo';

import useStyles from './useStyles';

const EXAMPLE_DATA = {
  licensedStates: '4/6',
  apr30: '4.00%',
  apr15: '3.00%',
};

const INITIAL_STATE = {
  bidRequestsVal: 0,
  responseTimeVal: 0,
  aprVal: 0,
  compResponseTimeVal: 0,
  compAprVal: 0,
  responseTimeDiff: 0,
  isResponseBetter: false,
  aprDiff: 0,
  isAprBetter: false,
};

const LoanOfficerDashboard = () => {
  const [dashboardStats, setDashboardStats] = useState(INITIAL_STATE);
  const classes = useStyles();
  const { t } = useTranslation();
  const { loanOfficerDashboard } = useLoanOfficerDashboard();

  useEffect(() => {
    const stats = calculateStats(loanOfficerDashboard);
    setDashboardStats({ ...dashboardStats, ...stats });
  }, [loanOfficerDashboard]);

  const {
    bidRequestsVal,
    responseTimeVal,
    aprVal,
    responseTimeDiff,
    isResponseBetter,
    aprDiff,
    isAprBetter,
  } = dashboardStats;

  const responseIcon = isResponseBetter ? 'expandMoreBetter' : 'expandLessWorse';
  const aprIcon = isAprBetter ? 'expandMoreBetter' : 'expandLessWorse';

  return (
    <div className={classes.container}>
      <Seo title={t('meta.LoanOfficerDashboard.title')} />
      <div className={classes.containerInside}>
        <Typography variant="h1" paragraph>
          {t('components.LoanOfficerDashboard.header')}
        </Typography>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h1" color="textSecondary" className={classes.cardNumber} align="center">
                    {bidRequestsVal}
                  </Typography>
                  <Typography variant="h2" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.connections')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h1" color="textSecondary" className={classes.cardNumber} align="center">
                    {`${Number.parseFloat(responseTimeVal).toFixed(1)} hrs`}
                  </Typography>

                  <Typography variant="h2" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.responseTime')}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" align="center">
                    <Icon name={responseIcon} /> {Number.parseFloat(responseTimeDiff).toFixed(1)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h1" color="textSecondary" className={classes.cardNumberSoon} align="center">
                    {EXAMPLE_DATA.licensedStates}
                  </Typography>
                  <Typography variant="h2" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.licensedStates')}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.comingSoon')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h1" color="textSecondary" className={classes.cardNumber} align="center">
                    {`${Number.parseFloat(aprVal).toFixed(2)}%`}
                  </Typography>
                  <Typography variant="h2" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.aprTotal')}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" align="center">
                    <Icon name={aprIcon} /> {`${Number.parseFloat(aprDiff).toFixed(2)}%`}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h1" color="textSecondary" className={classes.cardNumberSoon} align="center">
                    {EXAMPLE_DATA.apr30}
                  </Typography>
                  <Typography variant="h2" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.apr30')}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.comingSoon')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card className={classes.card}>
                <CardContent>
                  <Typography variant="h1" color="textSecondary" className={classes.cardNumberSoon} align="center">
                    {EXAMPLE_DATA.apr15}
                  </Typography>
                  <Typography variant="h2" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.apr15')}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" align="center">
                    {t('components.LoanOfficerDashboard.comingSoon')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
        <Typography variant="body1" paragraph className={classes.termSection} />
      </div>
    </div>
  );
};

export default LoanOfficerDashboard;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerDashboard/LoanOfficerDashboard.js